import styled from 'styled-components';

import { FlexRow } from 'styles/layouts';

export const FiltersSubUseCasesWrapper = styled(FlexRow)`
  gap: 8px;
  padding-bottom: 20px;
`;

export const SortSelectWrapper = styled.div`
  margin-left: auto;
`;
